export default __webpack_public_path__ + "static/media/iqrivas.7c2c2aee.jfif";